export function isNumber(value) {
  return /^\d+(\.\d+)?$/.test(value);
}
export function isNaN(value) {
  if (Number.isNaN) {
    return Number.isNaN(value);
  } // eslint-disable-next-line no-self-compare


  return value !== value;
}


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/utils/validate/number.js
// module id = 124
// module chunks = 1